export default "__VITE_ASSET__C5kTO$a9__"